import firestore from './firestore'
import state from './state'
import getters from './getters'
import actions from './actions'

export default {
  ...firestore,
  state,
  getters,
  actions
}